<div class="container-fluid mt-4">

  <div class="col-lg-12">
    <div class="card">

      <div class="card-header">
        <h5 class="election-title">Assigned Audit </h5>
      </div>
      <div class="card-body">

        <div class="full-page-table">
          <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover" [rows]="rows"
            [columns]="columns" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
            [externalPaging]="true" [count]="page.totalRecords" [offset]="page.pageNumber" [limit]="page.pageSize"
            (page)="setPage($event)" [virtualization]="false" [scrollbarV]="false" [scrollbarH]="true"
            [loadingIndicator]="loading">
            <ngx-datatable-column name="#" [sortable]="false">
              <!-- Custom Template for Action column -->
              <ng-template let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
                <span>{{
                  (page.pageNumber - 0) * page.pageSize + rowIndex + 1
                  }}</span>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column [sortable]="true" *ngFor="let column of columns" [name]="column.name"
              [prop]="column.prop">
              <!-- Custom Template for Action column -->
              <ng-template ngx-datatable-cell-template let-row="row" let-value="value">
                {{ value }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Action" [sortable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div class="d-flex align-items-center gap-2">
                  <a   (click)="navigateToChecklist(row.isocietydetailsid, 'InProcess', row.iSocietyDetailsTranID, row.iAllotAuditorID)"
                    [style.display]="row.redirectToHrRemark != null && !row.auditorRequestCancel  ? 'none' : 'inline-block'"
                    href="javascript:void(0)" title="Inspect Application"> <i class="fa fa-list"></i>
                  </a>
                  <a *ngIf="statusId == 0" (click)="navigateToChecklist(row.isocietydetailsid, 'InProcess', row.iSocietyDetailsTranID, row.iAllotAuditorID)"
                    [style.display]="row.redirectToHrRemark != null && !row.auditorRequestCancel  ? 'none' : 'inline-block'"
                    href="javascript:void(0)" title="Accept Application" class="btn btn-success btn-sm"> <i
                      class="fa fa-check"></i>
                  </a>

                  <a (click)="getsocietydata(row.isocietydetailsid)" href="javascript:void(0)"
                    title="Show Society Details" class="btn btn-primary btn-sm" data-bs-toggle="modal"
                    data-bs-target="#ShowData"><i class="fa fa-eye">
                    </i>
                  </a>
                  <a (click)="openRemarkModal(row.isocietydetailsid,'InCancelled',row.iAllotAuditorID)"
                    href="javascript:void(0)" title="Reject Audit"
                    [style.display]="(statusId == 0 && roleID == 17) ? 'none' : (statusId == 0 ? 'inline-block' : 'none')"
                    class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#AllotAuditor">
                    <i class="fa fa-times"></i>

                  </a>
                  <a href="javascript:void(0)" title="View AR Rejetcion" class="btn btn-warning btn-sm"
                    data-bs-toggle="modal"
                    [style.display]="statusId == 1 && row.auditorRequestCancel ? 'inline-block' : 'none'"
                    data-bs-target="#ChecklistRemark">
                    <i class="bi bi-chat-left-text"></i>
                  </a>



                  <a href="javascript:void(0)" title="AR Sendback Remark" class="btn btn-warning btn-sm"
                    data-bs-toggle="modal" [style.display]="statusId == 4 ? 'inline-block' : 'none'"
                    data-bs-target="#ARSendback">
                    <i class="bi bi-chat-left-text"></i>
                  </a>
                  <!-- <a type="button" title="Payment" class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#PaymentStatusAuditor">Payment Status</a> -->
                  <!-- <a (click)="openPaymentModal(row.isocietydetailsid)"  href="javascript:void(0)" title="Add Remarks"
                    [style.display]="!row.payment || row.auditorPaymentConfirm ? 'none' : 'inline-block'"
                    class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#PaymentStatusAuditor">
                    <i class="fa fa-credit-card"></i>
                  </a>
                  <a  href="javascript:void(0)" 
                  title="Payment" class="btn btn-primary btn-sm" 
                  style="margin-bottom: 10px;"
                  [style.display]="!row.AuditorPaymentReceived ? 'none' : 'inline-block'"
                 >
                  Payment Received
               </a> -->

                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </div>
    <!-- Button trigger modal -->
    <div class="modal fade" id="ShowData" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="ShowDataLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="ShowDataLabel">
              Society Details

            </h1>

            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" #objCloseButton></button>
          </div>
          <div class="modal-body">
            <div class="card-body">
              <h6 class="text-primary">{{showdata?.societyregist}}</h6>

              <div class="table-responsive">
                <table class="table table-bordered table-hover table-striped">
                  <tbody>
                    <tr>
                      <th class="font-medium">Society Name:</th>
                      <td>{{showdata?.sSocietyName}}</td>
                    </tr>

                    <tr>
                      <th class="font-medium">Society Category:</th>
                      <td>{{showdata?.scategoryname}}</td>
                    </tr>

                    <tr>
                      <th class="font-medium">Society Kind:</th>
                      <td>{{showdata?.ssocietykindname}}</td>
                    </tr>

                    <tr>
                      <th class="font-medium">Society Type:</th>
                      <td>{{showdata?.ssocietytypename}}</td>
                    </tr>

                    <tr>
                      <th class="font-medium">Division:</th>
                      <td>{{showdata?.sdivisionname}}</td>
                    </tr>

                    <tr>
                      <th class="font-medium">District:</th>
                      <td>{{showdata?.sdistrictname}}</td>
                    </tr>

                    <tr>
                      <th class="font-medium">Circle:</th>
                      <td>{{showdata?.scirclename}}</td>
                    </tr>

                    <tr>
                      <th class="font-medium">Block:</th>
                      <td>{{showdata?.sblockname}}</td>
                    </tr>

                    <tr>
                      <th class="font-medium">Address:</th>
                      <td>{{showdata?.sAddress1}} +{{showdata?.sAddress2}}</td>
                    </tr>

                  </tbody>
                </table>
              </div>
              <!-- <div class="form-group is-empty row m-1">
                <label for="nameInput" class="col-sm-10 control-label">Society Name:{{showdata?.sSocietyName}}</label>
              </div>
              <div class="form-group is-empty row m-1">
                <label for="nameInput" class="col-sm-10 control-label">Society
                  Category:{{showdata?.scategoryname}}</label>

              </div>
              <div class="form-group is-empty row m-1">
                <label for="nameInput" class="col-sm-10 control-label">Society
                  Kind:{{showdata?.ssocietykindname}}</label>

              </div>

              <div class="form-group is-empty row m-1">
                <label for="nameInput" class="col-sm-10 control-label">Society
                  Type:{{showdata?.ssocietytypename}}</label>

              </div>

              <div class="form-group is-empty row m-1">
                <label for="nameInput" class="col-sm-10 control-label">Division :{{showdata?.sdivisionname}}</label>
              </div>
              <div class="form-group is-empty row m-1">
                <label for="nameInput" class="col-sm-10 control-label">District:{{showdata?.sdistrictname}}</label>

              </div>

              <div class="form-group is-empty row m-1">
                <label for="nameInput" class="col-sm-10 control-label">Circle:{{showdata?.scirclename}}</label>

              </div>

              <div class="form-group is-empty row m-1">
                <label for="nameInput" class="col-sm-10 control-label">Block:{{showdata?.sblockname}}</label>

              </div>

              <div class="form-group is-empty row m-1">
                <label for="nameInput" class="col-sm-10 control-label">Address:{{showdata?.sAddress1}}</label>

                <label for="nameInput" class="col-sm-10 control-label">{{showdata?.sAddress2}}</label>


              </div> -->

            </div>
          </div>

          <!-- <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Understood</button>
        </div> -->
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="AllotAuditor" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="AllotAuditorLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h5 class="election-title" id="AllotAuditorLabel">Audit Cancellation Remark
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="reset()"
              aria-label="Close"></button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
            <div class="mb-3">
              <textarea class="form-control" id="remarkTextarea" rows="3" [(ngModel)]="remark.sRemark"
                placeholder="Enter Remark Here..." #remarkInput="ngModel" required></textarea>
            </div>
            <!-- Validation Message -->
            <div *ngIf="remarkInput.invalid && remarkInput.touched" class="text-danger">
              Remark is required.
            </div>

          </div>

          <!-- Modal Footer -->
          <div class="modal-footer">
            <!-- <button type="submit" class="btn btn-danger" data-bs-dismiss="modal" [disabled]="!remarksValid()"
              (click)="UpdateRemark()">Reject</button> -->
            <button type="submit" class="btn btn-danger" data-bs-dismiss="modal"
              [disabled]="!remarksValid() || isRejecting" (click)="UpdateRemark()">
              <span *ngIf="!isRejecting">Reject</span>
              <span *ngIf="isRejecting">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                loading...
              </span>
            </button>

          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="PaymentStatusAuditor" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="PaymentStatusAuditorLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="PaymentStatusAuditorLabel">Payment Received</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <!-- Amount (Disabled) -->
              <div class="col-md-6 mb-3">
                <label class="form-label">Amount</label>
                <input type="text" class="form-control" [(ngModel)]="paymentAmount" placeholder="Enter Amount"
                  [disabled]="true">
              </div>

              <!-- Upload Receipt (Required) -->
              <div class="col-md-6 mb-3">
                <label class="form-label" for="StatusUploadReceipt">Upload Receipt</label>
                <input type="file" class="form-control" (change)="onFileChange($event)"
                  [(ngModel)]="payment.sAmountReceiptAuditor" #receiptInput="ngModel">
                <div *ngIf="receiptInput.touched && !payment.sAmountReceiptAuditor" class="text-danger">
                  Please upload a receipt.
                </div>
              </div>

              <!-- Remark (Required) -->
              <div class="col-md-12 mb-3">
                <label class="form-label">Remark</label>
                <textarea class="form-control" [(ngModel)]="payment.sAmountRemarkAuditor"
                  placeholder="Write Your Remark..." rows="3" #remarksInput="ngModel"></textarea>
                <div *ngIf="remarksInput.touched && !payment.sAmountRemarkAuditor" class="text-danger">
                  Please enter a remark.
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" (click)="paymentRemark()">Mark Received</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="ChecklistRemark" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="ChecklistStatusReportLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content">

          <!-- Modal Header -->
          <div class="modal-header">
            <h5 class="modal-title" id="ChecklistStatusReportLabel">Rejection Remark</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">

            <!-- Role Selection -->
            <div class="col-lg-4 col-md-6 mb-3">
              <label class="form-label">Select Role</label>
              <select class="form-control" [(ngModel)]="selectedViewRole" required>
                <option value="0" disabled selected>Select Roles</option>
                <option value="1">Auditor</option>
                <option value="2">AR</option>
              </select>
            </div>

            <!-- Auditor Remark -->
            <div class="mb-3" *ngIf="selectedViewRole == 1">
              <label class="form-label">Auditor Cancellation Remark</label>
              <textarea class="form-control" rows="3" [(ngModel)]="hrremark" placeholder="No remarks available"
                #remarkInput="ngModel" disabled></textarea>
            </div>

            <!-- AR Remark -->
            <div class="mb-3" *ngIf="selectedViewRole == 2">
              <label class="form-label">AR Rejection Remark</label>
              <textarea class="form-control" rows="5" [(ngModel)]="arReject" placeholder="No remarks available"
                disabled></textarea>
            </div>

          </div>


        </div>
      </div>
    </div>
    <div class="modal fade" id="ARSendback" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
      aria-labelledby="ARSendbackLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
        <div class="modal-content">

          <!-- Modal Header -->
          <div class="modal-header">
            <h5 class="modal-title" id="ARSendbackLabel">
              <strong>AR SendBack Remark</strong>
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
            <div class="mb-3">
              <textarea id="arRemarkTextarea" class="form-control" rows="5" placeholder="No remarks available"
                [(ngModel)]="arsendback" name="hrremark" disabled></textarea>
            </div>
          </div>


        </div>
      </div>
    </div>


  </div>